import React, {Component} from 'react';
//import { BrowserRouter as Router, Link, Route } from 'react-router-dom';
//import ReactGA from 'react-ga'; //Google Analytics
import Middle from './Middle.js';
import CustomerDialog from './dialogs/CustomerDialogs.js';
import SaveDialog from './dialogs/SaveDialogs.js';
import QuoteDialog from './dialogs/QuoteDialogs.js';
import LoadingDialog from './dialogs/LoadingDialogs.js';
import RestartDialog from './dialogs/RestartDialogs.js';
import OptionHelpDialog from './dialogs/OptionHelpDialogs.js';
import {PrintDialog, PrintErrorDialog} from './dialogs/PrintDialogs.js';
//import PDFDialog from './dialogs/PDFDialogs.js';
import PDFPrintDialog from './dialogs/PDFPrintDialogs.js';
import {CustomDialog_1, CustomDialog_2} from './dialogs/CustomDialogs.js';
import {ExportDialog_1, ExportDialog_2} from './dialogs/ExportDialogs.js';
import {FeedbackDialog_1, FeedbackDialog_2, HelpDialog_1, HelpDialog_2, HelpDialog_3, Popup_Message} from './dialogs/HelpDialogs.js';
import data from './data.json'; //base data
import lookups from './lookups.json'; //lookup tables for all the possible choices
import mapping from './mapping.json'; //various choice permutations based on system pressure and model number
import swoosh from'./swoosh.jpg';
import TagManager from 'react-gtm-module';
import './App.min.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null, //configuration data
            customerPDF: null, //the pdf to be displayed
            currentDialog: 'loading', //the dialog to be displayed
            currentOptionHelp: null, //the option help to be displayed
            customerInfo: null, //customer information
            showCustInfo: false, //should the customer info dialog be displayed?
            url: "" //driveworks url for iframe
        };

        var DEV = false;

        //handlebars tokens for deployment
        this.urlSite = "https://3dstudio.mts.com";
        this.urlDW = "https://dw.3dstudio.mts.com";
        this.urlDW2 = "https://dw2.3dstudio.mts.com";

        if(DEV){
            this.urlSite = "https://3dstudio-dev.mts.com";
            this.urlDW = "https://dw.3dstudio-dev.mts.com";
            this.urlDW2 = "https://dw2.3dstudio-dev.mts.com";
        }

        //Google Analytics Tag Manager
        const tagManagerArgs = {gtmId: 'GTM-TCGPQCW'};
        TagManager.initialize(tagManagerArgs);
    }
    componentWillMount(){ //before render
        //parse query string determine actuator
        var a = parseInt(this.querystring("a")[0]); //get actuator querystring parameter
        data.actuator = (!isNaN(a) && a >= 0 && a < data.actuators.length) ? a : 0; //make sure the querystring parameter is valid, add to data
        //parse query string determine starting values of options choice
        //while we're looping, build a portion of the iframe url (set option to default if no querystring value)
        var url = this.urlDW + "/Integration?run=MTS_201_Sales_UI";
        var newData = data.actuators[data.actuator];
        for(var i = 0; i < newData.parameters.length; i++){
            var qs_val = this.querystring(newData.parameters[i].saveVar)[0];
            if(qs_val){
                newData.parameters[i].choice = qs_val;
                url+= "&" + newData.parameters[i].dwVar + "=" + (parseInt(newData.parameters[i].choice) + 1); //+1 - driveworks collection indexes start at 1
            }else{
                url+= "&" + newData.parameters[i].dwVar + "=" + 1; //set to default
            }
        }
        //update option mappings based on new choices
        for(var j = 0; j < newData.parameters.length; j++){
            var currData = this.choiceManager(newData, j, newData.parameters[j].choice);
            newData = currData;
        }

        this.setState({
            data: newData,
            url: url
        })
    }
    componentDidMount() { //after render

        //close menu if screen is clicked.  Doesn't work on iframe
        var scope = this;
        document.addEventListener('click', function (e) {
            var target = e.target;
            if(
                target.className != "opt_label" &&
                target.className != "opt_select" &&
                target.className != "fas fa-angle-right"
            ){
                var newData = scope.state.data;
                for(var i=0; i < newData.parameters.length; i++){
                    newData.parameters[i].hilited = false;
                }
                scope.setState({
                    data: newData
                })
            }
        });
        setTimeout(this.hideSpinner, 10000);
    }
    componentWillUnmount() {
    }

    closeCookieDialog = () => {
        var cookies = document.getElementById("cookies");
        cookies.parentNode.removeChild(cookies);
    }
    displayDialog = (type) => {
        //display customer info dialog just once
        if(type && this.state.showCustInfo && !this.state.customerInfo){
            return <CustomerDialog type={type} onClick={(dialog, customer) => this.saveCustomer(dialog, customer)} />
        //}else if(type == 'print'){
            //special case for print
            //console.log("joe");
        }else{
            switch (type) {
                case 'export_1':
                    return <ExportDialog_1 data={this.state.data} customer={this.state.customerInfo} urlDW2={this.urlDW2} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'export_2':
                    return <ExportDialog_2 onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;

                case 'save':
                    return <SaveDialog data={this.state.data} at={data.actuators[data.actuator].title} customer={this.state.customerInfo} lookups={lookups} urlSite={this.urlSite} urlDW2={this.urlDW2} onClick={(dialog) => this.setState({ currentDialog: dialog })} />
                    break;

                //case 'save':
                    //return <SaveDialog data={this.state.data} actuator={data.actuators[data.actuator].title} customer={this.state.customerInfo} urlSite={this.urlSite} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    //break;

                case 'quote':
                    return <QuoteDialog data={this.state.data} a={data.actuator} at={data.actuators[data.actuator].title} customer={this.state.customerInfo} urlSite={this.urlSite} urlDW={this.urlDW} urlDW2={this.urlDW2} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'feedback_1':
                    return <FeedbackDialog_1 urlSite={this.urlSite} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'feedback_2':
                    return <FeedbackDialog_2 onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'help_1':
                    return <HelpDialog_1 onClick={(dialog) => this.setState({currentDialog: dialog, showCustInfo: true})} /> //show customer info dialog mid stream
                    break;
                case 'help_2':
                    return <HelpDialog_2 customer={this.state.customerInfo} urlSite={this.urlSite} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'help_3':
                    return <HelpDialog_3 onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'custom_1':
                    return <CustomDialog_1 data={this.state.data} at={data.actuators[data.actuator].title} customer={this.state.customerInfo} lookups={lookups} urlSite={this.urlSite} urlDW2={this.urlDW2} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'custom_2':
                    return <CustomDialog_2 onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'restart':
                    return <RestartDialog data={data} onClick={(save) => this.restartDesign(save)} />
                    break;
                case 'option_help':
                    return <OptionHelpDialog data={this.state.data} option={this.state.currentOptionHelp} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'print':
                    return <PDFPrintDialog data={this.state.data} at={data.actuators[data.actuator].title} customer={this.state.customerInfo} urlSite={this.urlSite} urlDW2={this.urlDW2} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    break;
                case 'loading':
                    return <LoadingDialog />
                    break;
                //case 'print':
                    //return <PrintDialog data={this.state.data} at={data.actuators[data.actuator].title} customer={this.state.customerInfo} urlSite={this.urlSite} urlDW2={this.urlDW2} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    //break;
                //case 'pdf':
                    //return <PDFDialog pdf={this.state.currentPDF} onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    //break;
                //case 'print_error':
                    //return <PrintErrorDialog onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    //break;
                //case 'popup':
                    //return <Popup_Message onClick={(dialog) => this.setState({currentDialog: dialog})} />
                    //break;
            }
        }
    }
    set3dView(view){
        var dwIframe = document.getElementById("dwIframe").contentWindow;
        dwIframe.postMessage("run=MTS_201_Sales_UI&ViewAngle=" + view, this.urlDW);
    }
    saveCustomer(dialog, customer){
        this.setState({
            currentDialog: dialog,
            customerInfo: customer
        });
        var dwPost = [];
        dwPost.push("run=MTS_201_Sales_UI");
        dwPost.push("CustFirstName=" + customer.firstName);
        dwPost.push("CustLastName=" + customer.lastName);
        dwPost.push("CustEmail=" + customer.email);
        dwPost.push("CustCompany=" + customer.company);
        dwPost.push("CustPhone=" + customer.phone);
        dwPost.push("CustCountry=" + customer.country);
        dwPost.push("CustProject=" + customer.projectName);
        var dwIframe = document.getElementById("dwIframe").contentWindow;
        dwIframe.postMessage(dwPost.join("&"), this.urlDW);
        console.log(dwPost + this.urlDW);
    }
    restartDesign(save){
        if(save){
            var dwPost = [];
            var newData = this.state.data;
            //reset choice and create querystring for postmessage
            dwPost.push("run=MTS_201_Sales_UI");
            for(var i = 0; i < newData.parameters.length; i++){
                var dwVar = newData.parameters[i].dwVar;
                dwPost.push(dwVar + "=" + 0);
                newData.parameters[i].choice = 0;
            }
            //reset choices map
            for(var j = 0; j < newData.parameters.length; j++){
                var currData = this.choiceManager(newData, j, newData.parameters[j].choice);
                newData = currData;
            }
            //set state
            this.setState({
                data: newData,
                currentDialog: null
            });
            //update driveworks
            var dwIframe = document.getElementById("dwIframe").contentWindow;
            dwIframe.postMessage(dwPost.join("&"), this.urlDW);
        }else{
            this.setState({
                currentDialog: null
            });
        }
    }
    showOptions(optionIndex, type, choiceIndex){
        switch(type) {
            case "help":
                this.setState({
                    showCustInfo: false,
                    currentOptionHelp: optionIndex,
                    currentDialog: 'option_help'
                });
                break;
            case "choice":
                //get choice mappings
                var currData = this.choiceManager(this.state.data, optionIndex, choiceIndex, true);

                this.setState({
                    data: currData
                });

                if(optionIndex == 1){
                    //wait ten seconds if option = Model Number
                    this.setState({
                        showCustInfo: false,
                        currentDialog: 'loading'
                    });
                    setTimeout(this.hideSpinner, 10000);
                }

                var dwIframe = document.getElementById("dwIframe").contentWindow;

                //send postMessage to iframe updating all the left menu parameters
                var dwPost = [];
                dwPost.push("run=MTS_201_Sales_UI");
                for(var i = 0; i < currData.parameters.length; i++){
                    var dwVar = currData.parameters[i].dwVar;
                    var dwChoice = currData.parameters[i].choice;
                    dwPost.push(dwVar + "=" + (dwChoice + 1));
                    console.log(dwVar + "=" + (dwChoice + 1));
                }
      		    dwIframe.postMessage(dwPost.join("&"), this.urlDW);
                break;
            case "option":
                //hilite choice.  if choice is already hilited then unhilite
                var currData = this.state.data;
                var addHilite = !currData.parameters[optionIndex].hilited;
                for(var i = 0; i < currData.parameters.length; i++){
                    currData.parameters[i].hilited = false;
                }
                if(addHilite){
                    currData.parameters[optionIndex].hilited = true;
                }
                this.setState({
                    data: currData
                });
        }
    }
    hideSpinner = () =>{
        this.setState({
            currentDialog: null
        });
    }
    lookupChoices(optionIndex, map){
        //returns array of choices using the mapping tables
        //based on the option index and the map
        var choices = [];
        var mapArray = map.split(",");
        if(mapArray[0] == "all"){
            choices = lookups.options[optionIndex].choices;
        }else{
            for(var i = 0; i < mapArray.length; i++){
                choices.push(lookups.options[optionIndex].choices[mapArray[i]]);
            }
        }
        return choices;
    }
    choiceManager(currData, optionIndex, choiceIndex, userClick){
        //returns state data with correct choice mappings based on option and choice
        //if build is true skip the searching f
        var systemPressure = (optionIndex == 0 ? choiceIndex : currData.parameters[0].choice);
        var modelNumber = (optionIndex == 1 ? choiceIndex : currData.parameters[1].choice);

        currData.parameters[optionIndex].choice = choiceIndex;
        currData.parameters[optionIndex].hilited = false;

        //update the choices mapping except for system pressure and model number
        for (var i = 2; i < currData.parameters.length; i++){
            var map_old = currData.parameters[i].choices;
            var map_new = mapping.childs[systemPressure].childs[modelNumber].childs[i-2].map;
            var oldChoice = currData.parameters[i].choice;
            var oldChoices = this.lookupChoices(i, map_old);
            var newChoices = this.lookupChoices(i, map_new);
            var oldTitle = oldChoices[oldChoice] ? oldChoices[oldChoice].title : null;
            currData.parameters[i].choices = map_new;

            //determine if the SECOND SERVOVALVE should have choices
            if(i==7){
                var dynamicStroke = (optionIndex == 5 ? choiceIndex : currData.parameters[5].choice);
                var firstServo = (optionIndex == 6 ? choiceIndex : currData.parameters[6].choice);
                var dynamicStrokeMap = currData.parameters[5].choices;
                var firstServoMap = currData.parameters[6].choices;
                var dynamicStrokeChoices = this.lookupChoices(5, dynamicStrokeMap);
                var firstServoChoices = this.lookupChoices(6, firstServoMap);
                var dynamicStrokeValue = dynamicStrokeChoices[dynamicStroke].value;
                var firstServoTitle = firstServoChoices[firstServo].title;
                if(
                    dynamicStrokeValue < 10 ||
                    firstServoTitle == "252.36 - 85 lpm (22.5 gpm)" ||
                    firstServoTitle == "252.37 - 136 lpm (36 gpm)" ||
                    firstServoTitle == "252.38 - 204 lpm (54 gpm)" ||
                    firstServoTitle == "256.05A-01 - 190 lpm (50 gpm) Main, 3.8 lpm (1gpm) Pilot" ||
                    firstServoTitle == "256.09A-01 - 341 lpm (90 gpm) Main, 3.8 lpm (1gpm) Pilot" ||
                    firstServoTitle == "No Servovalve - No Manifold" ||
                    firstServoTitle == "No Servovalve - Single 252.2X Manifold Only" ||
                    firstServoTitle == "No Servovalve - Single 256.05/09A Manifold Only" ||
                    firstServoTitle == "No Servovalve - Single 252.3x Manifold Only" ||
                    firstServoTitle == "No Servovalve - Dual 252.2X Manifold Only"
                ){
                    currData.parameters[7].choices = "0";
                    newChoices = this.lookupChoices(i, "0");
                }
            }
            //if userClick see if the choice existed previously and hilite it
            //otherwise set choice to zero
            if(userClick && i != optionIndex){
                currData.parameters[i].choice = 0;
                for(var j = 0; j < newChoices.length; j++){
                    var newTitle = newChoices[j].title;
                    if(newTitle == oldTitle){
                        currData.parameters[i].choice = j;
                        break;
                    }
                }
            }
        }
        return currData;
    }
    showPopup(url, width, height){
        var leftPos = (window.screen.width / 2) - 251;
        var topPos = (window.screen.height / 2) - 462;
        var popup = window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,width=" + width + ",height=" + height + ",top=" + topPos + ",left=" + leftPos);
        if(popup == null){
            return(false);
        }
        return (true);
    }
    querystring(key) {
        //utility to parse querystrings to an object collection
       var re=new RegExp('(?:\\?|&)'+key+'=(.*?)(?=&|$)','gi');
       var r=[], m;
       while ((m=re.exec(document.location.search)) != null) r[r.length]=m[1];
       return r;
    }
    render() {
        var swooshStyle = {
            backgroundImage: `url(${swoosh})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '58em 6em'
        }
        return (
            <div className="App" style={swooshStyle}>
                <div id="border">
                    <div id="top">
                        <a className="logo" href={this.urlSite}><div id="logo"><img src="images/mtsLogo.png"/></div></a>
                        <div id="info">
                            <div id="header">
                                <div id="title">
                                    <span>3D DESIGN&nbsp;<b>STUDIO</b></span>
                                </div>
                                <div id="buttons">
                                    <div id="print" className="top_buttons" onClick={() => this.setState({currentDialog: 'print', showCustInfo: true})}>
                                        <i className={"fas fa-print"}></i>
                                        <div>PRINT</div>
                                    </div>
                                    <div id="export" className="top_buttons" onClick={() => this.setState({currentDialog: 'export_1', showCustInfo: true})}>
                                        <i className={"fas fa-file-export"}></i>
                                        <div>DOWNLOAD CAD</div>
                                    </div>
                                    <div id="save" className="top_buttons" onClick={() =>
                                        this.setState({ currentDialog: 'save', showCustInfo: true })}>
                                        <i className={"fas fa-folder-open"}></i>
                                        <div>SAVE</div>
                                    </div>
                                </div>
                            </div>
                            <div id="product">
                                <div id="name">{this.state.data.title + " Actuator"}</div>
                                {/*<div id="specs" onClick={() => this.setState({currentDialog: 'pdf', currentPDF: "http://www.discerncx.com/mts_react/configurator/pdfs/201G2_Condensed_More_Info.pdf", showCustInfo: false})}>More Information</div>*/}
                                {/*<div id="specs"><a href="pdfs/201G2_Condensed_More_Info.pdf#page=1&view=120" target="_blank">More Information</a></div>*/}
                                <div id="specs" onClick={() => this.showPopup("pdfs/201G2_Condensed_More_Info.pdf", 600, 750)}><i className="fas fa-file-pdf"></i> SPECIFICATIONS</div>
                                <div id="restart" onClick={() => this.setState({currentDialog: 'restart', showCustInfo: false})}>
                                    <span>Restart Design&nbsp;</span>
                                    <i className={"fas fa-undo-alt"}></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Middle data={this.state.data.parameters} actuator={this.state.data.title} url={this.state.url} onClick={(index, type, choiceIndex) => this.showOptions(index, type, choiceIndex)}></Middle>
                    <div id="bottom">
                        <div id="custom" onClick={() => this.setState({currentDialog: 'custom_1', showCustInfo: true})}><i className={"fas fa-cog"}></i><span>REQUEST CUSTOM OPTIONS</span></div>
                        <div id="nav">
                            <div id="holder">
                                <button onClick={() => this.set3dView(1)}>HOME</button>
                                <button onClick={() => this.set3dView(2)}>TOP</button>
                                <button onClick={() => this.set3dView(3)}>SIDE</button>
                                <button onClick={() => this.set3dView(4)}>FRONT</button>
                                &nbsp;
                                <i className={"fas fa-plus-circle"}></i>
                                <i className={"fas fa-minus-circle"}></i>
                                &nbsp;
                                <i className={"fas fa-chevron-circle-up"}></i>
                                <i className={"fas fa-chevron-circle-down"}></i>
                                &nbsp;
                                <i className={"fas fa-circle"}><span className={"fas fa-undo-alt"}></span></i>
                                <i className={"fas fa-circle"}><span className={"fas fa-undo-alt"}></span></i>
                            </div>
                        </div>
                        <div id="feedback">
                            <div id="quote" onClick={() => this.setState({currentDialog: 'quote', showCustInfo: true})}><i className={"fas fa-file-alt fa"}></i>&nbsp;REQUEST A QUOTE</div>
                            <div id="assistance">
                                <span id="help_btn" onClick={() => this.setState({currentDialog: 'help_1', showCustInfo: false})}>
                                    <i className={"fas fa-question-circle fa"}></i>&nbsp;HELP
                                </span>
                                <span id="fb_btn" onClick={() => this.setState({currentDialog: 'feedback_1', showCustInfo: false})}>
                                    <i className={"fas fa-comment fa"}></i>&nbsp;FEEDBACK
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="footer">2022 MTS System Corporation.  All Rights Reserved.   <a href="http://www.mts.com/en/privacy/index.htm"> Privacy & Legal.</a></div>
                <div id="cookies">
                    <span>We use cookies to enhance your experience, By continuing to use this site, you accept the use of cookies.</span>&nbsp;
                    <a href="#" id="cookie_learn">Learn more.</a>&nbsp;
                    <span id="cookie_close" onClick={this.closeCookieDialog}>Close [X]</span>
                </div>
                <iframe style={{display: "none"}} id="test_iframe"></iframe>
                { this.displayDialog(this.state.currentDialog) }
            </div>
        );
    }
}

export default App;
